import React from 'react'

function TextIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M8 19.8932H16V17.8932H8V19.8932ZM8 15.8932H16V13.8932H8V15.8932ZM6 23.8932C5.45 23.8932 4.97917 23.6974 4.5875 23.3057C4.19583 22.9141 4 22.4432 4 21.8932V5.89325C4 5.34325 4.19583 4.87242 4.5875 4.48075C4.97917 4.08908 5.45 3.89325 6 3.89325H14L20 9.89325V21.8932C20 22.4432 19.8042 22.9141 19.4125 23.3057C19.0208 23.6974 18.55 23.8932 18 23.8932H6ZM13 10.8932V5.89325H6V21.8932H18V10.8932H13Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  )
}

export default TextIcon
